module.exports = __webpack_public_path__ + "static/wxcode-a4b06572b2e6bd00f2f8ac37c63ecedf.png";